import $ from "jquery";
window.$ = window.jQuery = $;
import 'bootstrap';
import 'slick-carousel';
import 'jquery-ui/ui/widgets/autocomplete';
import 'jquery-ui/ui/widgets/datepicker';
import 'jquery-ui/ui/widgets/slider';
import 'datatables.net-bs4';
import 'jsvalidation';
//custom
import './common.js';
import './pages/account.js';
import './pages/home.js';
import './pages/product.js';
import './pages/checkout.js';
import './pages/search.js';
import './finder.js';
import './vue/account.js';
import './vue/checkout.js';
//new stuff
import './vue/layout.js';
